"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//import * as loadGoogle.mapsApi from "load-google-maps-api";
var $ = require("jquery");
require("../assets/js/maplabel.js");
var Mapa = /** @class */ (function () {
    function Mapa() {
        this.drawingManager = [];
        this.surfaceCoordinates = [[]];
        this.areaM2 = [];
        this.polygons = [];
        this.mapLabel = [];
        this.country = "España";
        this.nAreas = 0;
        this.setEvents();
        this.init();
    }
    Mapa.prototype.init = function () {
        this.areaM2[0] = 0;
        this.resizeMap();
        this.map = new google.maps.Map(document.getElementById("mapa"), {
            zoom: 7,
            center: {
                lat: 41,
                lng: 2
            },
            mapTypeId: google.maps.MapTypeId.SATELLITE,
            disableDefaultUI: true,
            zoomControl: true,
            tilt: 0
        });
        // Iniciamos el objeto de Google Maps que nos permite obtener los datos de una dirección
        this.geocoder = new google.maps.Geocoder();
        // Iniciamos el objeto de Google Maps que nos permite obtener la elevación de un punto
        this.elevator = new google.maps.ElevationService();
        this.createDrawingManager();
        this.addListenersTodrawingManager();
    };
    Mapa.prototype.createDrawingManager = function () {
        this.drawingManager[this.nAreas] = new (google.maps.drawing.DrawingManager)({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: false,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [google.maps.drawing.OverlayType.POLYGON]
            },
            polygonOptions: {
                id: this.nAreas,
                fillColor: "#015884",
                strokeColor: "#015884",
                fillOpacity: 0.7,
                strokeWeight: 5,
                clickable: false,
                editable: true,
                zIndex: 1
            }
        });
        this.mapLabel[this.nAreas] = new MapLabel({
            text: "",
            map: this.map,
            fontSize: 20,
            align: "center",
            zIndex: 5
        });
        this.drawingManager[this.nAreas].setMap(this.map);
    };
    Mapa.prototype.addListenersTodrawingManager = function () {
        var _this = this;
        var that = this;
        google.maps.event.addListener(this.drawingManager[this.nAreas], "polygoncomplete", function (polygon) {
            $(".map-information").show();
            $(".map-instructions").hide();
            $(".tools").show();
            $(".tools ul").show();
            $(".draw-text").hide();
            $(".map-collapse").addClass("vis-mobile");
            if ($(".map-collapse").hasClass("collapsed")) {
                $(".map-collapse").toggleClass("collapsed");
                $(".map-information .user-information").collapse("toggle");
            }
            _this.areaM2[_this.nAreas] = google.maps.geometry.spherical.computeArea(polygon.getPath());
            _this.resizeMap();
            google.maps.event.addListener(polygon, "dblclick", function (event) {
                if (event.vertex == undefined) {
                    return;
                }
                else {
                    _this.removeVertex(polygon, event.vertex);
                }
            });
        });
        google.maps.event.addListener(this.drawingManager[this.nAreas], "overlaycomplete", function (polygon) {
            if (polygon.type != google.maps.drawing.OverlayType.MARKER) {
                var that_1 = _this;
                // Switch back to non-drawing mode after drawing a shape.
                _this.drawingManager[_this.nAreas].setDrawingMode(null);
                // Add an event listener that selects the newly-drawn shape when the user
                // mouses down on it.
                var newShape = polygon.overlay;
                newShape.type = polygon.type;
                // para back
                var polygonBounds_1 = newShape.getPath();
                polygonBounds_1.id = _this.nAreas;
                _this.getPathBounds(polygonBounds_1, _this.nAreas);
                _this.areaM2[_this.nAreas] = google.maps.geometry.spherical.computeArea(polygonBounds_1);
                _this.setMapLabel(polygonBounds_1, polygonBounds_1.id);
                //polygon edit events - set, remove and insert node
                google.maps.event.addListener(polygonBounds_1, "set_at", function () {
                    that_1.getPathBounds(this, polygonBounds_1.id);
                    that_1.areaM2[polygonBounds_1.id] = google.maps.geometry.spherical.computeArea(this);
                    that_1.setMapLabel(polygonBounds_1, polygonBounds_1.id);
                    that_1.drawingManager[polygonBounds_1.id].setMap(that_1.map);
                    if ($(".map-collapse").hasClass("collapsed")) {
                        $(".map-collapse").toggleClass("collapsed");
                        $(".map-information .user-information").collapse("toggle");
                    }
                });
                google.maps.event.addListener(polygonBounds_1, "remove_at", function () {
                    that_1.getPathBounds(this, polygonBounds_1.id);
                    that_1.areaM2[polygonBounds_1.id] = google.maps.geometry.spherical.computeArea(this);
                    that_1.setMapLabel(polygonBounds_1, polygonBounds_1.id);
                    if ($(".map-collapse").hasClass("collapsed")) {
                        $(".map-collapse").toggleClass("collapsed");
                        $(".map-information .user-information").collapse("toggle");
                    }
                });
                google.maps.event.addListener(polygonBounds_1, "insert_at", function () {
                    that_1.getPathBounds(this, polygonBounds_1.id);
                    that_1.areaM2[polygonBounds_1.id] = google.maps.geometry.spherical.computeArea(this);
                    that_1.setMapLabel(polygonBounds_1, polygonBounds_1.id);
                    if ($(".map-collapse").hasClass("collapsed")) {
                        $(".map-collapse").toggleClass("collapsed");
                        $(".map-information .user-information").collapse("toggle");
                    }
                });
                _this.polygons.push(newShape);
            }
        });
    };
    Mapa.prototype.clearListeners = function () {
        for (var i = 1; i <= this.nAreas; i++) {
            google.maps.event.clearInstanceListeners(this.drawingManager[i]);
        }
    };
    Mapa.prototype.searchInMap = function () {
        this.resizeMap();
        $(".map-instructions").show();
        var that = this;
        var $form = $("#step1Form"), formData = {
            address: $form.find("input[name=Address]").val(),
            province: $form.find("input[name=Province]").val(),
            postalCode: $form.find("input[name=PostalCode]").val(),
            addressNumber: $form.find("input[name=Number]").val(),
            town: $form.find("input[name=City]").val()
        };
        var address = formData.address +
            " " +
            formData.addressNumber +
            "," +
            formData.town +
            "," +
            formData.postalCode +
            ", ," +
            that.country;
        this.geocodeAddress(address);
    };
    Mapa.prototype.geocodeAddress = function (address) {
        var _this = this;
        // Hacemos la llamada al servicio de Google Maps
        this.geocoder.geocode({
            address: address
        }, function (results, status) {
            $("#addressNotFound").hide();
            if (status === google.maps.GeocoderStatus.OK) {
                $(".address-alert").hide();
                // Modificamos el centro del mapa con los datos obtenidos
                _this.map.setZoom(28);
                _this.map.setMapTypeId(google.maps.MapTypeId.SATELLITE);
                _this.map.setCenter(results[0].geometry.location);
                // Guardamos las coordenadas
                _this.coordinates = results[0].geometry.location;
                // Obtenemos la elevación del punto seleccionado
                _this.elevator.getElevationForLocations({
                    locations: [results[0].geometry.location]
                }, function (results, status) {
                    _this.elevation = results[0].elevation;
                });
            }
            else {
                $("#addressNotFound").show();
                _this.searchInMap();
            }
        });
    };
    Mapa.prototype.numberWithPoints = function (x) {
        if (x != undefined) {
            x = Math.floor(x);
            x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
        else {
            x = 0;
        }
        return x;
    };
    Mapa.prototype.getPathBounds = function (polygonBounds, curPolygon) {
        // guardamos las coordenadas de cada punto del polígono
        this.surfaceCoordinates[curPolygon] = [];
        for (var i = 0; i < polygonBounds.length; i++) {
            this.surfaceCoordinates[curPolygon].push({
                lat: polygonBounds.getAt(i).lat(),
                lng: polygonBounds.getAt(i).lng()
            });
        }
    };
    Mapa.prototype.getSurface = function () {
        var floors = Number($("#map-floors").val());
        var surface = this.areaM2[0] * (floors === 0 ? 1 : floors);
        return Math.round(surface);
    };
    Mapa.prototype.saveSurfaceArea = function () {
        var surf = this.getSurface();
        if (surf !== 0) {
            $("#dimensions").val(surf);
        }
    };
    Mapa.prototype.resizeMap = function () {
        var mapElement = document.getElementById("mapa");
        mapElement.style.display = "block";
        var headerElement = window.getComputedStyle(document.getElementById("header"), null);
        mapElement.style.height =
            window.innerHeight -
                Number(headerElement.getPropertyValue("height").replace("px", "")) +
                "px";
        mapElement.style.minHeight =
            document.getElementsByClassName("map-controls")[0].scrollHeight + "px";
        google.maps.event.trigger(this.map, "resize");
    };
    Mapa.prototype.resetMap = function () {
        for (var i = 0; i < this.polygons.length; i++) {
            this.polygons[i].setMap(null);
        }
        for (var i = 0; i <= this.nAreas; i++) {
            this.drawingManager[i].setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
            if (i != 0) {
                this.drawingManager[i].setMap(null);
            }
        }
        this.areaM2 = [];
        /*this.drawingManager.setOptions({
                        drawingControl: true
                    });*/
        this.surfaceCoordinates = [[]];
        for (var i = 0; i <= this.nAreas; i++) {
            this.mapLabel[i].set("text", "");
        }
        this.nAreas = 0;
        $(".tools").hide();
        $(".map-collapse").removeClass("vis-mobile");
        $(".map-instructions").show();
        var submitStep2 = document.getElementsByClassName("map-information");
        var mapInstructions = (document.getElementsByClassName("map-instructions"));
        if (submitStep2[0]) {
            submitStep2[0].style.display = "none";
            mapInstructions[0].style.display = "block";
        }
    };
    Mapa.prototype.setEvents = function () {
        var _this = this;
        var that = this;
        $(".reset-map-drawings").on("click", function () {
            _this.resetMap();
        });
        $(".add-area").on("click", function () {
            _this.nAreas += 1;
            $(".tools ul").hide();
            $(".draw-text").show();
            _this.createDrawingManager();
            _this.addListenersTodrawingManager();
        });
        $(".map-collapse").on("click", function () {
            $(this).toggleClass("collapsed");
            $(".map-information .user-information").collapse("toggle");
        });
        $(".close-information").on("click", function () {
            $(".map-instructions").hide();
        });
        $(".roof").on("click", function () {
            $(".roof").removeClass("active");
            $(this).toggleClass("active");
            if ($(".map-collapse").hasClass("collapsed")) {
                $(".map-collapse").toggleClass("collapsed");
                $(".map-information .user-information").collapse("toggle");
            }
        });
    };
    Mapa.prototype.removeVertex = function (poly, vertex) {
        var path = poly.getPath();
        path.removeAt(vertex);
    };
    Mapa.prototype.getStaticMap = function (surfaceCoordinates) {
        var url = "https://maps.googleapis.com/maps/api/staticmap?";
        url += "key=AIzaSyBZO6984SQ0MRqg4sXTERCFObTQz9fHYtE";
        if (this.areaM2.reduce(function (a, b) {
            return a + b;
        }, 0) < 400) {
            url += "&zoom=19";
        }
        else if (this.areaM2.reduce(function (a, b) {
            return a + b;
        }, 0) < 1500) {
            url += "&zoom=18";
        }
        else {
            url += "&zoom=17";
        }
        url += "&size=360x130";
        url += "&maptype=satellite";
        url += "&sensor=false";
        //url += '&path=';
        for (var i = 0; i < surfaceCoordinates.length; i++) {
            url += "&path=color:0x017ebaff|weight:2|fillcolor:0x86dcfb80|";
            for (var j = 0; j < surfaceCoordinates[i].length; j++) {
                if (j != 0)
                    url += "|";
                url +=
                    surfaceCoordinates[i][j].lat + "," + surfaceCoordinates[i][j].lng;
            }
            url +=
                "|" + surfaceCoordinates[i][0].lat + "," + surfaceCoordinates[i][0].lng;
        }
        document.getElementById("imgMapa").setAttribute("src", url);
        //http://maps.googleapis.com/maps/api/staticmap?center=33.402285,-111.94271500000002&zoom=20&size=600x600&maptype=satellite&sensor=false&path=color%3ared%7Cweight:1%7Cfill%3awhite%7C33.4022475,-111.9426775%7C33.4022475,-111.9427525%7C33.4023225,-111.9427525%7C33.4023225,-111.9426775%7C33.4022475,-111.9426775
    };
    Mapa.prototype.setMapLabel = function (polygonBounds, num) {
        this.mapLabel[num].set("position", this.getCenterInPolygon(polygonBounds));
        this.mapLabel[num].set("text", this.numberWithPoints(this.areaM2[num]) + " m2");
    };
    Mapa.prototype.getCenterInPolygon = function (polygonBounds) {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < polygonBounds.length; i++) {
            bounds.extend(polygonBounds.getAt(i));
        }
        bounds.extend(polygonBounds.getAt(polygonBounds.length - 1));
        var movemaplat = bounds.getCenter().lat();
        var movemaplng = bounds.getCenter().lng();
        var myLatlng = new google.maps.LatLng(movemaplat, movemaplng);
        return myLatlng;
    };
    return Mapa;
}());
exports.Mapa = Mapa;
